import AnalyticsUtil from 'utils/AnalyticsUtil';

export const PRIVACY_VISIBILITY_OPTIONS = {
    PUBLIC: 'public',
    PRIVATE: 'private',
    SUBSCRIBERS: 'subscribers',
    CONNECTIONS: 'subscribers',
    GROUPS: 'groups',
    CUSTOM: 'custom',
    FOLLOWING: 'following'
};

export const PRIVACY_DEFAULT_OPTIONS = [
    {
        value: PRIVACY_VISIBILITY_OPTIONS.PRIVATE,
        textKey: 'privacy.alert.only.me'
    },
    {
        value: PRIVACY_VISIBILITY_OPTIONS.SUBSCRIBERS,
        textKey: 'privacy.alert.connections'
    },
    {
        value: PRIVACY_VISIBILITY_OPTIONS.GROUPS,
        textKey: 'privacy.alert.groups'
    },
    {
        value: PRIVACY_VISIBILITY_OPTIONS.PUBLIC,
        textKey: 'privacy.alert.everyone'
    }
];

export const OPTION_NO_VALUE = '0';

export const SELECTION_OPTION = {
    ALL: 'all',
    CUSTOM: 'custom'
};

export const PAST_ACTIVITY_PRIVACY_SETTINGS_ANALYTICS = {
    GO_TO_PAST_ACTIVITY_PRIVACY: 'User CLicks on the Update Past Activities privacy Link',
    USER_SELECTS_ALL_PAST_ACTIVITIES: 'User Selects all past activities privacy option',
    USER_SELECTS_CUSTOM_PAST_ACTIVITIES: 'User Selects custom past activities privacy option',
    USER_SAVES_PAST_ACTIVITIES: 'User Saves past activities privacy changes'
};

export const pushUserPastActivityPrivacySettingsChangeEventToAnalytics = (action, label) => {
    AnalyticsUtil.push({
        event: 'track_event',
        category: 'User Past Activity Privacy Settings Changed Events',
        action: action,
        label: label
    });
};
